import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import useContactos from "features/Contactos/hooks/useContactos"
import {
  getLibradorEmailsOptions,
  newDocumentoSelector,
} from "features/Crear/redux/selectors/newDocumentoSelectors"
import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import {
  changeLibradorEmail,
  setLibrador,
} from "features/Crear/redux/slices/newDocumentoSlice"
import { formatDireccion } from "features/Crear/utils/formatDireccion"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { Dropdown } from "primereact/dropdown"
import { Tooltip } from "primereact/tooltip"
import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { ButtonAction } from "../ConceptosTable"
import LibradorSearchForm from "./LibradorSearchForm"

const LibradorCard = ({ canEditLibradoLibrador }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [showEmails, setShowEmails] = useState(false)
  const { librador, isLibrado } = useSelector(newDocumentoSelector)
  const { colorSelected } = useSelector(newDocumentoSettingsSelector)
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { editContacto } = useContactos()
  const emailsOptions = useSelector(getLibradorEmailsOptions)

  const dispatch = useDispatch()
  const dropdrownRef = useRef()

  const deleteLibrador = () => {
    setShowEmails(false)
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setLibrador(null))
  }

  // @ts-expect-error TS(2554): Expected 5 arguments, but got 1.
  const editLibrador = () => editContacto(librador?.id)

  const selectLibradorEmail = (e: $TSMigrationFixMe) => {
    dispatch(changeLibradorEmail(e.value))
    setShowEmails(false)
  }

  const hasEmails = librador?.emails?.length > 1
  const ableToEdit = canEditLibradoLibrador && librador && isLibrado

  return (
    <div className='border-0 card'>
      <div
        style={{ backgroundColor: colorSelected }}
        className={`card-header header-blue d-flex align-items-center justify-content-between ${
          !librador && "opacity-5"
        }`}
      >
        <p className='mb-0'>{t("crear.facturaRec.supplierDataHeader")}</p>

        {ableToEdit ? (
          <span className='d-flex align-items-center'>
            <ButtonAction
              onClick={editLibrador}
              iconName='pen'
              className='mr-1 tx-white'
              classNameIcon='icon-size-md'
            />
            <ButtonAction
              onClick={deleteLibrador}
              iconName='xmark'
              className='mr-1 tx-white'
              classNameIcon='icon-size-md'
            />
          </span>
        ) : null}
      </div>

      <div className='p-0 card-body'>
        <div className='container p-3'>
          {librador ? (
            <>
              <p className='h5 font-weight-500 d-flex align-items-center'>
                {librador?.razonSocial}
              </p>

              <p className='mb-2'>{librador?.cif}</p>

              <p className='mb-2'>{formatDireccion(librador)}</p>

              <div className='mb-2'>
                <Dropdown
                  autoFocus
                  showOnFocus
                  value={librador?.email}
                  onChange={selectLibradorEmail}
                  options={emailsOptions}
                  // @ts-expect-error TS(2769): No overload matches this call.
                  ref={dropdrownRef}
                  style={{ display: showEmails ? "" : "none" }}
                />

                {!showEmails && (
                  <span
                    className={`emailLibradoChange ${
                      hasEmails ? "cursor-pointer" : ""
                    }`}
                    onClick={() => {
                      setShowEmails(hasEmails)
                      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                      dropdrownRef.current.state.overlayVisible = true
                    }}
                  >
                    {librador.email || ""}

                    <Tooltip
                      disabled={!hasEmails}
                      target='.emailLibradoChange'
                      content='Cambia el email'
                    />

                    {hasEmails ? (
                      <>
                        <FontAwesomeIcon icon={["fal", "angle-down"]} />
                      </>
                    ) : null}
                  </span>
                )}
              </div>

              <p className='mb-2'>{librador?.telefono}</p>
            </>
          ) : (
            <LibradorSearchForm />
          )}
        </div>
      </div>
    </div>
  )
}

export default LibradorCard
